import React, { useEffect,useState } from "react"
import { PageHeader } from "../../molecules/PageHeader"
import { connect } from "react-redux"
import avatarRing from "../../assets/images/avatar-ring.svg"
import {
  GET_CAT_IMAGE,
  SHARED_PAGE_DESCRIPTION,
  WHAT_TO_DO,
  PLAN_DINNER,
  PERSONALIZE_CONCIERGE,
  CLOSE_BUTTON,
  JOURNAL_POPUP_URL,
  BACK_BUTTON,
  JOURNAL_LABEL,
  HEALTH_DECISION_TAG,
} from "../../constants/messages"
import { CustomModal, Button } from "../../atoms"
import history from "../../history"
import { ArrowLeftOutlined } from "@ant-design/icons"
import Tag from "../../components/Tag/Tag"
import { Avatar } from "antd"
import SpaceModal from "../../components/SpaceModal/SpaceModal"
import { FirebaseContext } from "../../firebase"
import { TextTag as Text } from "../../atoms"
import "./JournalPage.scss"
import { getChatSpaceName, getPartnerNameorNickName } from "../../utils/helpers"
import _ from "../../utils/lodashUtils"

const MeetConcierge = (props) => {
  const { dateState, partnerState, userState } = React.useContext(
    FirebaseContext
  )
  const { partnerDetails, myPartner } = props

  const chatSpaceName = getChatSpaceName(dateState, partnerDetails)
  const partnerName = getPartnerNameorNickName(
    partnerState,
    myPartner,
    partnerDetails
  )

  const [typeformEmbedBond, setTypeFormEmbedBond] = useState(false)
  const [typeformEmbedKeepur, setTypeFormEmbedKeepur] = useState(false)

  const openBondForm = () => {
    // typeformEmbedBond.typeform.open()
    setTypeFormEmbedBond(true)
  }
  const openKeepurForm = () => {
    // typeformEmbedKeepur.typeform.open()
    setTypeFormEmbedKeepur(true)
  }

  const goBackHandle = () => {
    history.push("/dashboard")
  }

  useEffect(() => {
    if (typeformEmbedBond) {
      const script = document.createElement("script")
      script.innerHTML = `var myLandbot = new Landbot.Container({
      container: '#myLandbot',
      configUrl: 'https://chats.landbot.io/v3/H-658880-9DO7ZRZIE6R6MV7M/index.json',
    });`
      script.id = "test"
      document.body.appendChild(script)
    } else {
      const script = document.getElementById("test")
      if (script) {
        document.body.removeChild(script)
      }
    }
  }, [typeformEmbedBond])


  useEffect(() => {
    if (typeformEmbedKeepur) {
      const script = document.createElement("script")
      script.innerHTML = `var myLandbot2 = new Landbot.Container({
      container: '#myLandbot2',
      configUrl: 'https://chats.landbot.io/v3/H-659112-V4P3YFXT01RJ1ZLL/index.json',
    });`
      script.id = "test"
      document.body.appendChild(script)
    } else {
      const script = document.getElementById("test")
      if (script) {
        document.body.removeChild(script)
      }
    }
  }, [typeformEmbedKeepur])

  return (
    <div className="meet-keepurr-container">
      <div className="journal-wrapper">
        <div className="back-btn">
          <div className="page-header">
            <PageHeader
              onClick={goBackHandle}
              icon={<ArrowLeftOutlined />}
              btnText={BACK_BUTTON}
              headerText={JOURNAL_LABEL(chatSpaceName)}
            />
          </div>
        </div>
        <div>
          <CustomModal
            destroyOnClose={true}
            keyboard={false}
            footer={[
              <Button onClick={() => setTypeFormEmbedBond(false)}>
                {CLOSE_BUTTON}
              </Button>,
            ]}
            title={PLAN_DINNER}
            visible={typeformEmbedBond}
          >
            <div
              id="myLandbot"
              style={{ width: "100%", height: "500px" }}
            ></div>
          </CustomModal>
          <CustomModal
            destroyOnClose={true}
            keyboard={false}
            footer={[
              <Button onClick={() => setTypeFormEmbedKeepur(false)}>
                {CLOSE_BUTTON}
              </Button>,
            ]}
            title={PLAN_DINNER}
            visible={typeformEmbedKeepur}
          >
            <div
              id="myLandbot2"
              style={{ width: "100%", height: "500px" }}
            ></div>
          </CustomModal>
        </div>
        <div className="keepurr-profile">
          <div className="profile-image">
            <div className="display-img">
              <div className="avatar">
                <img
                  className="ovalBg"
                  src={avatarRing}
                  alt="backgroud circle"
                />
                <Avatar
                  id="uploadAvatar"
                  size={90}
                  src={GET_CAT_IMAGE(chatSpaceName)}
                />
              </div>
            </div>
            <div className="display-information-container">
              <div className="display-name">
                <Text textType="pageHeading"> {chatSpaceName} </Text>
                <SpaceModal buttonType={"link"} chatSpaceName={chatSpaceName} />
              </div>
              <div className="description">
                <Text textType="sectionTextPrimary">
                  {SHARED_PAGE_DESCRIPTION(chatSpaceName)}
                </Text>
              </div>
            </div>
          </div>
          <div className="what-to-do">
            <Text textType="sectionHeading">{WHAT_TO_DO(partnerName)}</Text>
            <div className="options">
              <div className="bond-pop-up">
                <Tag
                  text={PERSONALIZE_CONCIERGE}
                  icon={false}
                  onClick={openKeepurForm}
                />
              </div>
              {/* show this if it's not prod as per ticket 521 */}
              {_.get(process.env, "REACT_APP_ENV", "QA") !== "production" && (
                <div className="bond-pop-up">
                  <Tag
                    text={HEALTH_DECISION_TAG}
                    icon={false}
                    onClick={openKeepurForm}
                  />
                </div>
              )}
              <div className="bond-pop-up">
                <Tag text={PLAN_DINNER} icon={false} onClick={openBondForm} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = (state) => ({
  myPartner: _.get(state, "auth.partner", {}),
  partnerDetails: _.get(state.invitePeople, "partnerDetails"),
})
export default connect(mapStateToProps, {})(MeetConcierge)
